<template>
	<v-card>
		<form @submit.prevent="save">
			<v-toolbar dark class="p3" color="#ed217c">
				<v-toolbar-title>
					<h4 class="px-4">{{ $t('Invite New Users') }}</h4>
				</v-toolbar-title>
			</v-toolbar>
			<v-card-text>
				<smart-input
					style="direction: ltr"
					textarea rows="4" hint="Enter the users' email addresses separated by commas or spaces"
					:required="true" :label="$t('Users Email')" v-model="form.emails" :error="errors.name"
				/>
			</v-card-text>
			<v-card-actions>
				<v-btn type="submit" color="success" :loading="inProgress">
					<v-icon>email</v-icon>
					{{ $t('invite') }}
				</v-btn>
			</v-card-actions>
		</form>
	</v-card>
</template>

<script>
import InvitationService from "../../services/InvitationService";
import InvitationModule from "../../store/modules/Invitation.module";

export default {
	name: "InvitationsCard",
	data () {
		return {
			inProgress: false,
			form: {
				emails:null
			},
			errors: [],
		};
	},
	methods: {
		async save () {
			// this.inProgress = true;
			try {
				const sended = await InvitationService.sendInvitations(this.form.emails);
				if (sended.length) {
					this.$notification.success(this.$t("Invitations sent Successfully"));
				} else {
					this.$notification.error(this.$t("No Invitations sent"), this.$t("Verify the integrity of emails"));
				}
				this.form.emails = null;
				await this.$store.dispatch(InvitationModule.types.FETCH);
			} catch (e) {
				this.$notification.error(this.$t("No Invitations sent"), this.$t("Verify the integrity of emails"));
			}

			// await CompanyService.save(Object.assign(this.company, this.form));
		},
	},
};
</script>

<style scoped>

</style>
